// extracted by mini-css-extract-plugin
module.exports = {"title":"styles__title--1_rwU","faqListItem":"styles__faqListItem--3IhNp","container":"styles__container--3OFHl"};